import { PROYECT, api_get, api_post } from "services/api";

import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";

import { addLabelArray } from "helpers/addLabelArray";
import { ROUTE_CYCLES_TYPES } from "redux/reducers/buildings/routeCycles/routeCyclesTypes";
import { convertToObjById } from "helpers/convertToObject";

const {
  SET_ROUTE_CYCLES,
  NEW_ROUTE_CYCLE,
  SET_NEW_ROUTE_CYCLE,
  EDIT_ROUTE_CYCLE,
  SET_EDITED_ROUTE_CYCLE,
  CLEAR_ROUTE_CYCLES,
  HANDLE_ROUTE_CYCLES_INPUTS,
} = ROUTE_CYCLES_TYPES;

const urlRoutes = `${process.env.REACT_APP_URL}${PROYECT}/buildings/route_cycles`;
const getUrlRoutesCycles = idStation =>
  `${process.env.REACT_APP_URL}${PROYECT}/buildings/route_cycles?stations=${idStation}`;
const getUrlCollectPeriods = idStation =>
  `${process.env.REACT_APP_URL}${PROYECT}/buildings/collect_periods?stations=${idStation}`;
const getUrlRoutes = idStation =>
  `${process.env.REACT_APP_URL}${PROYECT}/buildings/routes/stations/${idStation}`;
const getUrlEmployees = idStation =>
  `${process.env.REACT_APP_URL}${PROYECT}/stations/${idStation}/employees`;

const getUrlOpenRoute = idRouteCycle =>
  `${process.env.REACT_APP_URL}${PROYECT}/buildings/route_cycles/${idRouteCycle}/open_cycle`;

export function newRouteCycle() {
  return {
    type: NEW_ROUTE_CYCLE
  };
}
export function clearRouteCycles() {
  return {
    type: CLEAR_ROUTE_CYCLES
  };
}
export function editRoute(id) {
  return {
    type: EDIT_ROUTE_CYCLE,
    payload: id
  };
}

export const handleRouteCyclesInputsAction = (key, value) => async dispatch => {
  dispatch({ type: HANDLE_ROUTE_CYCLES_INPUTS, payload: { key, value } });
};

export const fetchRouteCycles = (idStation = null) => async dispatch => {
  dispatch(startRequestComp("loadingRouteCycles"));
  try {
    const [routes, routeCycles, collectPeriods, employees] = await Promise.all([
      api_get(getUrlRoutes(idStation)),
      api_get(getUrlRoutesCycles(idStation)),
      api_get(getUrlCollectPeriods(idStation)),
      api_get(getUrlEmployees(idStation))
    ]);

    dispatch({
      type: SET_ROUTE_CYCLES,
      payload: {
        routeCycles,
        routes: addLabelArray(routes, "name"),
        routesMap: convertToObjById(routes),
        employees: employees.employees,
        collectPeriods: addLabelArray(collectPeriods, "name"),
        collectPeriodsMap: convertToObjById(collectPeriods)
      }
    });
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp("loadingRouteCycles"));
  }
};

export const fetchNewRouteCycle = body => async dispatch => {
  dispatch(startRequestComp("loadingNewRouteCycle"));
  try {
    const response = await api_post(urlRoutes, body);

    dispatch({
      type: SET_NEW_ROUTE_CYCLE,
      payload: response
    });
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp("loadingNewRouteCycle"));
  }
};

export const sendOpenRouteCycle = (
  idRouteCycle,
  onSuccess = () => {}
) => async dispatch => {
  dispatch(startRequestComp("loadingOpenRouteCycle"));

  const urlOpenRoute = getUrlOpenRoute(idRouteCycle);

  try {
    const response = await api_post(urlOpenRoute, {});

    dispatch({
      type: SET_EDITED_ROUTE_CYCLE,
      payload: response
    });

    if (onSuccess) {
      onSuccess();
    }
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp("loadingOpenRouteCycle"));
  }
};
